// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e52b40bc","455":"20870c04","977":"0d5af66a"}[chunkId] + ".chunk.js";
};